import axios from 'axios';
import { API_BASES } from '../config';

const GATEWAY_BASE_URL = API_BASES.gateway;

export const getMyProfile = () => axios.get(`${GATEWAY_BASE_URL}/api/users/me`);
export const updateMyProfile = (data) => axios.put(`${GATEWAY_BASE_URL}/api/users/me`, data);
export const deleteMyAccount = (pwd) =>
  axios.delete(`${GATEWAY_BASE_URL}/api/users/me`, { data: { currentPassword: pwd } });
export const changeMyPassword = (data) =>
  axios.put(`${GATEWAY_BASE_URL}/api/users/me/change-password`, data);
export const setMyPassword = (data) =>
  axios.post(`${GATEWAY_BASE_URL}/api/users/me/password`, data);
export const getUserById = (id) => axios.get(`${GATEWAY_BASE_URL}/api/users/${id}`);
export const updateUserByAdmin = (id, data) =>
  axios.put(`${GATEWAY_BASE_URL}/api/users/${id}`, data);
export const deleteUserByAdmin = (id) => axios.delete(`${GATEWAY_BASE_URL}/api/users/${id}`);
export const resetUserPassword = (id) =>
  axios.post(`${GATEWAY_BASE_URL}/api/users/${id}/reset-password`);
export const requestPasswordReset = (username) =>
  axios.post(`${GATEWAY_BASE_URL}/api/users/request-password-reset`, { username });
export const getAllUsers = () => axios.get(`${GATEWAY_BASE_URL}/api/users`);
export const sendContactMessage = (data) =>
  axios.post(`${GATEWAY_BASE_URL}/api/users/contact`, data);
export const registerUser = (data) =>
  axios.post(`${GATEWAY_BASE_URL}/api/users/register`, data);
export const sendCreatorRequest = (data) =>
  axios.post(`${GATEWAY_BASE_URL}/api/users/solicitud-creador`, data);
